<template>
  <LoginLayout class="sendmail">
    <h1 class="title">パスワード再設定</h1>
    <p>
      パスワードをお忘れの場合、ご登録されているメールアドレスを入力し、「パスワード再設定」のボタンをタップしてください。<br />ご登録のメールアドレスに、パスワード再設定のご案内メールをお送りいたします。
    </p>
    <div class="form-box">
      <AdornmentsInput
        type="email"
        :prefixIcon="MailInverseIcon"
        placeholder="メールアドレス"
        autocomplete="nope"
        v-model="resetMail"
        @keypress.enter="onSubmit"
      />
    </div>
    <Button :small="isSP" primary :disabled="isDisabled" @click="onSubmit">パスワード再設定</Button>
    <template #link>
      <router-link :to="{ name: isSP ? 'SP/login' : 'Login' }">ログイン画面に戻る</router-link>
    </template>
    <Dialog v-if="error.isError" :title="error.title" :message="error.massage" @ok="onDialogOk" okText="閉じる" />
    <LoadingMessage v-if="sendMail.isShowLoading" message="メール送信中…" />
  </LoginLayout>
</template>

<script>
import { mapState } from 'vuex'
import LoginLayout from '@/components/templates/LoginLayout'
import Dialog from '@/components/molecules/ModalDialog'
import LoadingMessage from '@/components/molecules/LoadingMessage'
import Button from '@/components/atoms/Button'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import MailInverseIcon from '@/components/icons/mailInverse'

export default {
  name: 'SendMail',
  components: {
    LoginLayout,
    Button,
    AdornmentsInput,
    Dialog,
    LoadingMessage,
  },
  data() {
    return {
      MailInverseIcon,
    }
  },
  computed: {
    ...mapState({
      isSP: state => state.app.isSP,
      error: state => state.login.error,
      sendMail: state => state.login.sendMail,
    }),
    isDisabled() {
      return !this.sendMail.isDirty
    },
    resetMail: {
      get() {
        return this.sendMail.mail
      },
      set(value) {
        this.$store.dispatch('login/updateSendMail', value)
      },
    },
    isSent() {
      return this.sendMail.isSent
    },
  },
  watch: {
    isSent() {
      if (this.isSent) {
        this.$router.push({ name: this.isSP ? 'SP/resetSend' : 'Complete' })
      }
    },
  },
  mounted() {
    this.$store.dispatch('login/init')
  },
  methods: {
    onSubmit() {
      this.$store.dispatch('login/sendResetMail')
    },
    onDialogOk() {
      this.$store.dispatch('login/updateIsError', false)
    },
  },
}
</script>

<style lang="postcss" scoped>
.title {
  font-size: 21px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 48px;
  text-align: center;
}

.form-box {
  align-self: center;
  margin-top: 24px;
  width: 384px;
}

.responsive {
  @media screen and (max-width: 559px) {
    .title {
      font-size: 16px;
      margin-bottom: 36px;
    }

    .form-box {
      width: 100%;
    }
  }
}
</style>
